// LES DEUX VIDEOS DE LA BANNIERE D'ACCUEIL : UNE SEULE CHARGEE
//
// La composition « Accueil — Bannière » pose deux blocs vidéo en fond d'un même groupe :
// .accueil_hero_desktop et .accueil_hero_mobile. Le SCSS n'en affiche qu'un, l'autre passe en
// display: none. Le navigateur, lui, télécharge les DEUX fichiers : le CSS n'entre pas dans
// l'algorithme de sélection de ressource d'un <video>, et l'attribut autoplay fait en plus
// ignorer preload. Chrome et Firefox lancent même la lecture (l'autoplay muet y est toujours
// autorisé) ; Safari la suspend tant que l'élément est invisible, mais charge quand même.
//
// Trois pièges, tous voulus :
//
// 1. Retirer l'attribut src ne suffit PAS. Une modification de src est sans effet tant que
//    load() n'est pas appelé : c'est load() qui avorte le téléchargement en cours. Le script
//    vivant en pied de page, le fichier est déjà en vol quand il s'exécute — on n'évite pas la
//    requête, on l'interrompt, soit la quasi-totalité des octets.
// 2. Ne jamais écrire video.src = ''. Une chaîne vide se résout en l'URL de la page : le
//    navigateur télécharge le HTML et lève un MEDIA_ERR_SRC_NOT_SUPPORTED en console.
// 3. Après un load(), l'attribut autoplay ne relance pas la lecture tout seul. On rappelle
//    play() au rétablissement.
//
// Aucune adresse n'est écrite dans la page : le markup enregistré reste du Gutenberg pur, sans
// data-src que l'éditeur perdrait au nettoyage ou signalerait comme contenu inattendu. C'est ce
// script qui mémorise l'adresse, dans une WeakMap, AVANT de la retirer.
//
// A savoir : ce script ne tourne PAS dans l'éditeur, qui charge donc bien toutes les vidéos de
// la page. C'est le coût direct de la forme retenue, et il est assumé.

(function () {

    // Deux structures coexistent : la banniere actuelle, ou les videos sont des blocs video
    // poses en fond, et l'ancienne, batie sur deux core/cover, dont des copies vivent encore
    // dans les pages deja construites. Le script couvre les deux ; la seconde entree pourra
    // partir quand plus aucun contenu ne portera de .wp-block-cover.accueil_hero.
    var SELECTEUR = '.accueil_hero_video video, .accueil_hero .wp-block-cover__video-background';

    // Une WeakMap plutôt qu'une propriété posée sur l'élément : rien n'est exposé dans le DOM,
    // et l'entrée disparaît avec le noeud.
    var sources = new WeakMap();

    // « Affichée » au sens du rendu, pas au sens d'une largeur de fenêtre : getClientRects() est
    // vide dès qu'un display: none est posé sur l'élément OU sur un de ses ancêtres. Le point de
    // bascule reste donc écrit une seule fois, dans _accueil.scss — aucun 1200 ici. Bootstrap
    // borne d'ailleurs à 1199.98px, qu'un window.innerWidth > 1200 manquerait.
    function est_affichee( element ) {
        return element.getClientRects().length > 0;
    }

    function ajuster( video ) {

        // C'est la BOITE de la video qu'on mesure, pas la video elle-meme : c'est elle que le
        // SCSS passe en display: none.
        var boite = video.closest( '.accueil_hero_video, .wp-block-cover' );

        if ( ! boite ) {
            return;
        }

        // 1. La bannière est affichée : on rétablit la source si elle manque.
        if ( est_affichee( boite ) ) {

            if ( video.getAttribute( 'src' ) ) {
                return;
            }

            var url = sources.get( video );

            if ( ! url ) {
                return;
            }

            video.setAttribute( 'src', url );
            video.load();

            // Muette et playsinline : la lecture sans geste est autorisée partout, le rejet ne
            // devrait pas arriver. On l'avale quand même, une promesse rejetée sans catch salit
            // la console.
            var lecture = video.play();

            if ( lecture && lecture.catch ) {
                lecture.catch( function () {} );
            }

            return;
        }

        // 2. La bannière est cachée : on mémorise puis on coupe.
        if ( ! video.getAttribute( 'src' ) ) {
            return;
        }

        if ( ! sources.has( video ) ) {
            sources.set( video, video.getAttribute( 'src' ) );
        }

        video.removeAttribute( 'src' );
        video.load();
    }

    function ajuster_toutes() {
        document.querySelectorAll( SELECTEUR ).forEach( ajuster );
    }

    function demarrer() {

        var videos = document.querySelectorAll( SELECTEUR );

        if ( ! videos.length ) {
            return;
        }

        // On mémorise AVANT de toucher quoi que ce soit : une fois l'attribut retiré, plus rien
        // dans la page ne porte l'adresse.
        videos.forEach( function ( video ) {
            var url = video.getAttribute( 'src' );

            if ( url ) {
                sources.set( video, url );
            }
        } );

        ajuster_toutes();

        // Sur téléphone, la barre d'adresse qui se rétracte au défilement émet des resize en
        // rafale. Sans conséquence ici : l'état ne change pas, ajuster() ressort aussitôt.
        var en_attente = false;

        window.addEventListener( 'resize', function () {

            if ( en_attente ) {
                return;
            }

            en_attente = true;

            window.requestAnimationFrame( function () {
                en_attente = false;
                ajuster_toutes();
            } );
        } );
    }

    // Le script est chargé en pied de page : la bannière est déjà analysée, on agit tout de suite
    // plutôt que d'attendre DOMContentLoaded, qui attend encore les feuilles de style. Chaque
    // milliseconde gagnée est de la vidéo non téléchargée.
    if ( document.querySelectorAll( SELECTEUR ).length ) {
        demarrer();
    } else {
        document.addEventListener( 'DOMContentLoaded', demarrer );
    }

})();
